import dayjs from "dayjs";
import React from "react";
import { formatearValor } from "../../../helpers/formatearPesos";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";
import { Tooltip } from "@mui/material";
import { AttachMoneyOutlined, CalendarMonthOutlined, Check, LocationOnOutlined } from "@mui/icons-material";

export const ViewInactiveForm = ({ data }) => {

	return (
        <div style={{ width: 650, padding: 30, display: 'flex', flexFlow: 'column noWrap', gap: 20 }}>
            <div style={{ display: 'flex', gap: 15, justifyContent: 'space-between', padding: 15 }}>
                <div style={{ display:'flex', gap: 15 }}>
                    <img 
                        src={ data?.baja?.imagen?.secure_url || require('../../../assets/img/placeholder.png') } 
                        alt="Imagen"
                        style={{
                            width: 120,
                            height: 120,
                            borderRadius: '50%',
                            objectFit: 'cover'
                        }}
                    />

                    <div style={{ display: 'flex', flexFlow: 'column wrap', justifyContent: 'center' }}>
                        <>
                            <label style={{ fontWeight: 600, fontSize: 13 }}>Placa:
                                <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 12 }}>{ data?.placa }</span>
                            </label>
                        </>
                        <>
                            <label style={{ fontWeight: 600, fontSize: 13 }}>Código JSP7:
                                <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 12 }}>{ data?.codigo_inteligente?.toUpperCase() }</span>
                            </label>
                        </>
                        <>
                            <label style={{ fontWeight: 600, fontSize: 13 }}>Categoría:
                                <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 12 }}>{ convertirLetraMayus(data?.categoria?.nombre) }</span>
                            </label>
                        </>
                        <>
                            <label style={{ fontWeight: 600, fontSize: 13 }}>Registrado:
                                <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 12 }}>{ dayjs(data?.creado).format('DD-MM-YYYY') }</span>
                            </label>
                        </>
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: 10, background: '#f5f5f5', padding: 15, borderRadius: 6 }}>
                <Tooltip title='Ubicación' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, flexGrow: 1, flexShrink: 1, flexBasis: 0 }}>
                    <LocationOnOutlined fontSize="small" htmlColor="#003650" />
                    <span style={{ fontSize: 12, textAlign: 'center', cursor: 'default', fontWeight: 600 }}>{ convertirLetraMayus(data?.ubicacion) }</span>
                </Tooltip>

                <Tooltip title='Fecha de compra' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, flexGrow: 1, flexShrink: 1, flexBasis: 0 }}>
                    <CalendarMonthOutlined fontSize="small" htmlColor="#003650" />
                    <span style={{ fontSize: 12, textAlign: 'center', cursor: 'default', fontWeight: 600 }}>{ dayjs(data?.fecha_compra).format('DD-MM-YYYY') }</span>
                </Tooltip>

                <Tooltip title='Valor de compra' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, flexGrow: 1, flexShrink: 1, flexBasis: 0 }}>
                    <AttachMoneyOutlined fontSize="small" htmlColor="#003650" />
                    <span style={{ fontSize: 12, textAlign: 'center', cursor: 'default', fontWeight: 600 }}>{ `$${ formatearValor(data?.valor_compra) }` }</span>
                </Tooltip>
            </div>

            <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 14 }}>Descripción:
                <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 13 }}>{ convertirLetraMayus(data?.descripcion) }</span>
            </label>
         
            <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 14 }}>Motivo de baja:
                <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 13 }}>{ convertirLetraMayus(data?.baja?.motivo) }</span>
            </label>

            <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 14 }}>Disposición:
                <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 13 }}>{ convertirLetraMayus(data?.baja?.disposicion) }</span>
            </label>

            {
                data?.observacion && (
                    <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 14 }}>Observación:
                        <span style={{ fontWeight: 'normal', marginLeft: 5, fontSize: 13 }}>{ convertirLetraMayus(data?.observacion) }</span>
                    </label>

                )
            }
            
            <div>
                <label style={{ fontWeight: 600, textAlign: 'justify', fontSize: 14 }}>Responsable:</label>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, height: 100, marginTop: 10, marginBottom: 20 }}>
                    <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                        <span style={{ fontSize: 11, position: 'absolute', textAlign: 'center', width: 200, top: -30, fontWeight: 600 }}>Anterior</span>
                        <div style={{ width: 12, height: 12, background: '#dbdbdb', borderRadius: '50%' }} />
                        
                        {
                            data?.historial_responsables?.length > 0 && (
                                <>
                                    <span style={{ fontSize: 11, position: 'absolute', textAlign: 'center', width: 200, top: 30 }}>{ convertirLetraMayus(data?.historial_responsables?.at(-1)?.usuario?.nombre, true) }</span>
                                    <span style={{ fontSize: 10, position: 'absolute', textAlign: 'center', width: 200, top: 45 }}>{ dayjs(data?.historial_responsables?.at(-1)?.fecha_asignacion).format('DD-MM-YYYY') }</span>
                                </>
                            )
                        }
                        
                    </div>

                    <div style={{ width: 250, height: 3, borderRadius: 4, background: 'linear-gradient(90deg, rgba(245,245,245,1) 0%, rgba(121,187,65,1) 100%)' }} />

                    <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                        <span style={{ fontSize: 11, position: 'absolute', textAlign: 'center', width: 200, top: -30, fontWeight: 600 }}>Actual</span>
                        <div style={{ width: 20, height: 20, background: '#79bb41', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Check htmlColor="#fff" style={{ fontSize: 14 }} />
                        </div>
                        
                        <span style={{ fontSize: 11, position: 'absolute', textAlign: 'center', width: 200, top: 30, fontWeight: 600 }}>Baja</span>
                        <span style={{ fontSize: 10, position: 'absolute', textAlign: 'center', width: 200, top: 45, fontWeight: 600 }}>{ dayjs(data?.responsable.fecha_asignacion).format('DD-MM-YYYY') }</span>
                    </div>
                </div>
            </div>
        </div>
    )
}